import { changeLocale } from '@formkit/vue';
import { useI18n } from 'vue-i18n';

export function useLanguageSwitcher() {
	const { locale } = useI18n();

	const availableLanguages = [
		{ code: 'en', name: 'English' },
		{ code: 'fr', name: 'Français' },
		{ code: 'es', name: 'Español' },
	] as const;

	const currentLanguage = computed(() => {
		return availableLanguages.find((lang) => lang.code === locale.value) || availableLanguages[0];
	});

	function changeLanguage(newLocale: string) {
		if (availableLanguages.some((lang) => lang.code === newLocale)) {
			locale.value = newLocale;
			localStorage.setItem('locale', newLocale);
			changeLocale(newLocale);
		}
	}

	return { locale, availableLanguages, currentLanguage, changeLanguage };
}
